import moment from 'moment';
import { createSelector } from 'reselect';
import { genderFromServer } from '../../helpers/gender';
import validator from '../../helpers/validator';
import { MAIN_DATA_CHILD } from '../../constants/applicant';
import {
  CITIZENSHIP_TYPES,
  MAIN_DATA_FIELD_NAMES
} from '../../constants/citizenship';
import { API_DATE_FORMAT, DATE_FORMAT } from '../../helpers/date';

export const mainDataSelector = state => state.mainDataChild;

export const mainDataValuesSelector = createSelector(
  mainDataSelector,
  subState => subState.data
);

export const mainDataBlurSelector = createSelector(
  mainDataSelector,
  subState => subState.blur
);

export const mainDataFullValuesSelector = createSelector(
  mainDataSelector,
  subState => ({
    ...subState.data,
    snils: subState.snils ? subState.snils : subState.data.snils
  })
);

export const getUserBirthdateSelector = createSelector(
  mainDataValuesSelector,
  subState => moment(subState.birthdate, DATE_FORMAT).clone()
);

export const getBirthdateBeforeFourteenAndHalfAgo = createSelector(
  getUserBirthdateSelector,
  birthdate => {
    const fourteenAndHalfYearsAgo = moment()
      .subtract(180, 'days')
      .subtract(14, 'years');
    const dateOfBirth = moment(birthdate, DATE_FORMAT);

    return dateOfBirth.isAfter(fourteenAndHalfYearsAgo);
  }
);

export const mainDataValidationSelector = createSelector(
  mainDataValuesSelector,
  getBirthdateBeforeFourteenAndHalfAgo,
  mainData => validator(mainData, MAIN_DATA_CHILD)
);

export const mainDataFullValidationSelector = createSelector(
  mainDataValuesSelector,
  getBirthdateBeforeFourteenAndHalfAgo,
  (mainData, beforeFourteenAndHalf) =>
    validator(mainData, MAIN_DATA_CHILD, null, beforeFourteenAndHalf)
);

export const mainDataErrorsSelector = createSelector(
  mainDataValidationSelector,
  subState => subState.errors
);

export const mainDataIsValidSelector = createSelector(
  mainDataValidationSelector,
  subState => subState.valid
);

export const mainDataEditableFieldsSelector = createSelector(
  mainDataSelector,
  subState => subState.editableFields
);

const getSnils = snils => {
  if (!snils) {
    return '';
  }

  if (typeof snils === 'string') {
    return snils;
  }

  return snils.snils_number || '';
};

export const getUserSnilsSelector = createSelector(
  mainDataFullValuesSelector,
  subState => getSnils(subState.snils)
);

export const mainDataBirthRegPlaceSelector = createSelector(
  mainDataValuesSelector,
  subState => subState[MAIN_DATA_FIELD_NAMES.birthRegistrationPlace]
);

export const appealSubmitPersonSelector = createSelector(
  mainDataFullValuesSelector,
  subState => ({
    middle_name_absent: !subState.middleName,
    snils: getSnils(subState.snils),
    last_name: subState.lastName || '',
    first_name: subState.firstName || '',
    middle_name: subState.middleName || '',
    gender: genderFromServer(subState.gender),
    birth_day: subState.birthdate
      ? moment(subState.birthdate, DATE_FORMAT)
          .clone()
          .format(API_DATE_FORMAT)
      : '',
    phone: subState.phone || '',
    email: subState.email || '',
    citizenship: CITIZENSHIP_TYPES[subState.citizenship] || ''
  })
);
